import _ from 'lodash';
const getDefaultState = () => {
  return {
    selectedItemsAllPages: {},
    storeCustomerName: null
  };
};

//const state = getDefaultState();
const state = state===undefined?getDefaultState():state;

const mutations = {
  SET_SELECTED_ITEMS_ALL_PAGES (state, { data, page }) {
    state.selectedItemsAllPages[page] = _.cloneDeep(data);
  },
  RESET_SELECTED_ITEMS_ALL_PAGES (state) {
    state.selectedItemsAllPages = getDefaultState().selectedItemsAllPages;
  },
  STORE_CUSTOMER_NAME (state, {name}) {
    state.storeCustomerName = name;
  },
  RESET_CUSTOMER_NAME (state) {
    state.storeCustomerName = getDefaultState().storeCustomerName;
  },
};
const actions = {
  updateSelectedItems ({ commit }, payload) {
    commit('SET_SELECTED_ITEMS_ALL_PAGES', payload);
  },
  resetSelectedItems ({ commit }) {
    commit('RESET_SELECTED_ITEMS_ALL_PAGES');
  },
  storeCustomerName({ commit }, payload){
    commit('STORE_CUSTOMER_NAME', payload);
  },
  resetCustomerName({commit}) {
    commit('RESET_CUSTOMER_NAME');
  }
};
export default {
  state,
  mutations,
  actions,
};
